import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 67 54"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m66.86 53.206-7-1-3.5-.5-5.5-1.002-2.5-.5-2.5-.5-2-.5-2-.5-2-.5-3-1-3-1-3.5-1.5-2-1-3.5-2-3.76-2.491-2.24-1.509-3.01-1.991-5.25-3.5L0 23.726 29.36.205z"
    }, null, -1)
  ])))
}
export default { render: render }